/**
 * last-played — scan localStorage pour identifier le dernier jeu joué.
 *
 * Lecture seule sur le store géré par game-progression.ts (zone intouchable).
 * Utilisé par le lobby grimoire pour proposer "Continuer le voyage" sur le
 * jeu le plus récemment terminé.
 */
const STORAGE_PREFIX = 'labrain.progression.';
function safeStorage() {
    if (typeof window === 'undefined')
        return null;
    try {
        return window.localStorage;
    }
    catch {
        return null;
    }
}
export function listProgressionEntries() {
    const ls = safeStorage();
    if (!ls)
        return [];
    const out = [];
    for (let i = 0; i < ls.length; i += 1) {
        const key = ls.key(i);
        if (!key || !key.startsWith(STORAGE_PREFIX))
            continue;
        if (key === `${STORAGE_PREFIX}__probe__`)
            continue;
        const slug = key.slice(STORAGE_PREFIX.length);
        if (!slug)
            continue;
        const raw = ls.getItem(key);
        if (!raw)
            continue;
        try {
            const parsed = JSON.parse(raw);
            if (typeof parsed.bestLevel !== 'number' || typeof parsed.currentLevel !== 'number') {
                continue;
            }
            if (typeof parsed.lastRunAt !== 'string' || !parsed.lastRunAt)
                continue;
            out.push({
                slug,
                lastRunAt: parsed.lastRunAt,
                bestLevel: parsed.bestLevel,
                currentLevel: parsed.currentLevel,
            });
        }
        catch {
            /* ignore corrupted entries */
        }
    }
    return out;
}
export function findLastPlayed() {
    const all = listProgressionEntries();
    if (all.length === 0)
        return null;
    return all.reduce((best, e) => {
        if (Date.parse(e.lastRunAt) > Date.parse(best.lastRunAt))
            return e;
        return best;
    }, all[0]);
}
/**
 * Pure helper for tests : pick the most recent entry from a list.
 */
export function pickMostRecent(entries) {
    if (entries.length === 0)
        return null;
    return entries.reduce((best, e) => {
        if (Date.parse(e.lastRunAt) > Date.parse(best.lastRunAt))
            return e;
        return best;
    }, entries[0]);
}
//# sourceMappingURL=last-played.js.map